import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LogService } from 'app/services/log.service';
import { VersionService } from 'app/services/version.service';

@Component({
  selector: 'app-update-notification',
  templateUrl: './update-notification.component.html',
  styleUrls: ['./update-notification.component.css']
})
export class UpdateNotificationComponent {
  constructor(
    private versionService: VersionService,
    private snackBar: MatSnackBar,
    private logService: LogService
  ) {
    this.logService.log(`UpdateNotificationComponent`);
    this.versionService.newVersionAvailable.subscribe(isAvailable => {
      if (isAvailable) {
        this.snackBar.open('A new version is available', 'REFRESH', {
          duration: 0,
          verticalPosition: 'bottom',
          horizontalPosition: 'center',
          panelClass: ['update-snackbar']
        }).onAction().subscribe(() => this.versionService.applyUpdate());
      }
    });
  }

  checkForUpdate() {
    this.versionService.newVersionAvailable.next(false);
  }

  forceRefresh() {
    window.location.reload();
  }
}
